import { graphql } from '@/gql/graphql';
import { OrganizationDetailToolbarFragment } from '@/layouts/OrganizationDetail/OrganizationDetailToolbarFragment';

export const OrganizationNavigationFragment = graphql(`
  fragment OrganizationNavigation on event {
    id
    permissions
    ...OrganizationDetailToolbar
  }
`, [OrganizationDetailToolbarFragment]);

export const TeamNavigationFragment = graphql(`
  fragment TeamNavigation on team {
    id
    root_event_id
    permissions
  }
`);

export const OrganizationTabFragment = graphql(`
  fragment OrganizationTab on event {
    ...OrganizationNavigation
    id
    title
  }
`, [OrganizationNavigationFragment]);

export const GetOrganizationDetailLayout = graphql(`
  query GetOrganizationDetailLayout(
    $organizationId: uuid!
    $personId: String!
  ) {
    event_by_pk(id: $organizationId) {
      ...OrganizationNavigation
      ...OrganizationDetailToolbar
      ...OrganizationTab
    }
  }
`, [
  OrganizationNavigationFragment,
  OrganizationDetailToolbarFragment,
  OrganizationTabFragment,
]);
